import {
  FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS,
} from './../../mutation-types';

export default {
  [FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS](state, organizationMemberProductBusinessHour) {
    state.all = organizationMemberProductBusinessHour;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMemberProductBusinesshour/mutations.js